import { t } from "i18next";
import { useState } from "react";
import { ExternalReviewModal } from "../../../modals";
import classes from "./ExternalReviewComponent.module.css";

const ExternalReviewComponent = ({ itemId, entityType, onNavigateToReview }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleClick = () => {
    setModalOpen(true);
  };

  return (
    <>
      <div className={classes.illustrationContainer} onClick={handleClick}>
        <div className={classes.illustration}>
          <div className={classes.illustrationContent}>
            <div className={classes.circle}>
              <span className={classes.infoText}>i</span>
            </div>
            <span className={classes.tagText}>{t("externalReview_tag")}</span>
          </div>
        </div>
      </div>

      <ExternalReviewModal
        show={isModalOpen}
        onHide={() => setModalOpen(false)}
        entityType={entityType}
        entityId={itemId}
        onNavigateToReview={onNavigateToReview}
      />
    </>
  );
};

export default ExternalReviewComponent;
